import React from 'react';
import Cookies from 'js-cookie';
import LoginForm from '../../shared/components/forms/LoginForm';
import { doLogin } from '../../api/auth';
import './LoginPage.scss';
import { TOKEN_NAME } from '../../shared/constants';
import { useQueryClient } from 'react-query';
import { LoginI } from '../../interfaces/auth';
import { useNavigate } from 'react-router-dom';
import { AxiosResponse } from 'axios';
import useAuth from '../../shared/hooks/useAuth';

const LoginPage: React.FC = () => {
  const { setAuth }: any = useAuth();
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const handleSubmit = async (values: LoginI) => {
    try {
      const { data }: AxiosResponse = await doLogin(values);
      setAuth(data);
      Cookies.set(TOKEN_NAME, data.authToken);
      queryClient.invalidateQueries();
      if (data?.roles?.includes('SUPER_ADMIN')) {
        navigate('/users');
      } else if (data?.roles?.includes('FINANCE') || data?.roles?.includes('DATABASE')) {
        navigate('/films');
      } else if (data?.roles?.includes('SALE')) {
        navigate('/salesheets');
      } else {
        navigate('/');
      }
    } catch (error) {
      console.log('error', error);
    }
  };

  return (
    <div className="login-container">
      <div className="content-page">
        <LoginForm handleSubmit={handleSubmit} />
      </div>
    </div>
  );
};

export default LoginPage;
